module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "frontmatterPage",
    attrs: {
      "id": "fm"
    }
  }, [_c('p', {
    staticClass: "paraY1"
  }, [_vm._v("Books by Terrence J. Winschel")]), _vm._v(" "), _c('p', {
    staticClass: "paraY"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Triumph and Defeat:")])]), _vm._v(" "), _c('p', {
    staticClass: "paraNoIndentY"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("The Vicksburg Campaign ")]), _vm._v("(1998)")]), _vm._v(" "), _c('p', {
    staticClass: "paraY"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Vicksburg:")])]), _vm._v(" "), _c('p', {
    staticClass: "paraNoIndentY"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Fall of the Confederate Gibraltar ")]), _vm._v("(1999)")]), _vm._v(" "), _c('p', {
    staticClass: "paraY"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("The Civil War Diary of a Common Soldier:")])]), _vm._v(" "), _c('p', {
    staticClass: "paraNoIndentY"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("William Wiley of the 77th Illinois Infantry")]), _vm._v("(2001)")]), _vm._v(" "), _c('p', {
    staticClass: "paraY"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Vicksburg is the Key:")])]), _vm._v(" "), _c('p', {
    staticClass: "paraNoIndentY"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("The Struggle for the Mississippi River ")]), _vm._v("(2003)")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-126f81d5","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/TriumphandDefeat_fm.vue
// module id = 57
// module chunks = 0